import CatalogReportScreen from "features/catalogue/components/Settings/CatalogReport/componet/CatalogReportScreen";
import React, { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import CatalogSessionScreen from "./CatalogSessionScreen";
import { useClientContext } from "context/ClientContext";
import SortContext from "context/SortContext";
import { useGlobalContext } from "context/GlobalContext";

function CatalogTypePageWrapper() {
  let location = useLocation();
  const { setTimeSpentBtn, setRenewBtn, setShowExpiryTimer } = useClientContext();
  const { setSearch } = useContext(SortContext);
  const { setSearchPlaceHolder } = useGlobalContext();

  useEffect(() => {
    location?.state?.isSession ? setSearch(true) : setSearch(false);
    setSearchPlaceHolder("Search by Catalog name");
    return () => {
      setTimeSpentBtn(false);
      setRenewBtn(false);
      setSearchPlaceHolder("");
      setSearch(false);
      setShowExpiryTimer(false);
    };
  }, []);

  if (location?.state?.isSession) {
    setRenewBtn(true);
    return <CatalogSessionScreen />;
  } else {
    if (location?.state?.isActiveCatalog) {
      setShowExpiryTimer(true);
    }
    setTimeSpentBtn(true);
    return <CatalogReportScreen />;
  }
}

export default CatalogTypePageWrapper;
